// ============================= //
// ACTIONS                      //
// ============================= //

export const setPropositionsSent = (propositions) => ({
  type: "SET_PROPOSITIONS_SENT",
  payload: propositions,
});

export const setPropositionPending = (proposition) => ({
  type: "SET_PROPOSITION_PENDING",
  payload: proposition,
});

export const setSelectedProposition = (proposition) => ({
  type: "SET_SELECTED_PROPOSITION",
  payload: proposition,
});

export const setPropositionsAccepted = (propositions) => ({
  type: "SET_PROPOSITIONS_ACCEPTED",
  payload: propositions,
});

// ============================= //
// ENVOI D’UNE PROPOSITION       //
// ============================= //

export const sendProposition = (formData, token) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/propositions`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l’envoi de la proposition");
      }

      await dispatch(fetchPropositionsSent(token));

      return data;
    } catch (error) {
      console.error("Erreur envoi proposition:", error);
      throw error;
    }
  };
};


// ============================= //
// PROPOSITION EN ATTENTE        //
// ============================= //

export const fetchPropositionPending = (token, idProjet, idPrestataire) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      if (!idProjet || !idPrestataire) {
        throw new Error("idProjet et idPrestataire sont requis");
      }

      const formData = new FormData();
      formData.append("idProjet", idProjet);
      formData.append("idPrestataire", idPrestataire);

      const response = await fetch(`${apiUrl}/api/propositions/pending`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement de la proposition en attente");
      }

      dispatch(setPropositionPending(data.proposition || null));
      return data.proposition;
    } catch (error) {
      console.error("Erreur fetchPropositionPending:", error);
      throw error;
    }
  };
};


// ============================= //
// REFUSER UNE PROPOSITION       //
// ============================= //

export const declineProposition = (token, proposition) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      if (!proposition?.idProposition) {
        throw new Error("PROPOSITION.id requis pour refuser une proposition");
      }


      const formData = new FormData();
      formData.append("idProposition", proposition.idProposition);

      const response = await fetch(`${apiUrl}/api/propositions/decline`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du refus de la proposition");
      }

      // Mise à jour de la proposition en attente après le refus
      await dispatch(fetchPropositionPending(token, proposition.projet.idProjetClient, proposition.profilPrestataire.idPrestataire));

      return data;
    } catch (error) {
      console.error("Erreur declineProposition:", error);
      throw error;
    }
  };
};


// ============================= //
// PROPOSITIONS ENVOYÉES         //
// ============================= //

export const fetchPropositionsSent = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/propositions/sent`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des propositions envoyées");
      }

      dispatch(setPropositionsSent(data.propositionsSent || []));
      return data.propositionsSent;
    } catch (error) {
      console.error("Erreur fetchPropositionsSent:", error);
      throw error;
    }
  };
};

export const fetchPropositionsAccepted = (token,idProjet = null) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/propositions/accepted${idProjet?"?idProjet="+idProjet:""}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des propositions acceptées");
      }

      dispatch(setPropositionsAccepted(data.propositionsAccepted || []));
      return data.propositionsAccepted;
    } catch (error) {
      console.error("Erreur fetchPropositionsAccepted:", error);
      throw error;
    }
  };
};

export const acceptProposition = (idProposition, token) => async () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  try {
    const formData = new FormData();
    formData.append("idProposition", idProposition);

    const response = await fetch(`${apiUrl}/api/propositions/accept`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Erreur lors de l'acceptation");

    return data;
  } catch (error) {
    console.error("Erreur acceptProposition:", error);
    throw error;
  }
};


export const confirmAcceptance = (idProposition,paymentIntentId, token) => async () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  try {
    const formData = new FormData();
    formData.append("idProposition", idProposition);
    formData.append("paymentIntentId",paymentIntentId);
    const response = await fetch(`${apiUrl}/api/propositions/confirmAcceptance`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Erreur lors de la confirmation");

    return data;
  } catch (error) {
    console.error("Erreur confirmAcceptance:", error);
    throw error;
  }
};


